import { ThunkAction } from 'redux-thunk'
import store, { RootState } from '..'
import { debtApi } from '../../apis'
import { DebtEntity, DebtFilter } from '../../models'
import {
  DebtAction,
  SET_DEBTS,
  SET_DEBTS_LOADED,
  SET_DEBT_FILTER,
  SET_TOTAL_DEBTS,
} from '../types'

export const setDebts = (debts: DebtEntity[]): DebtAction => ({
  type: SET_DEBTS,
  payload: debts,
})

export const setTotalDebts = (total: number): DebtAction => ({
  type: SET_TOTAL_DEBTS,
  payload: total,
})

export const setDebtsLoaded = (loaded: boolean): DebtAction => ({
  type: SET_DEBTS_LOADED,
  payload: loaded,
})

export const setDebtFilter = (filter: DebtFilter): DebtAction => ({
  type: SET_DEBT_FILTER,
  payload: filter,
})

export const loadDebts = (): ThunkAction<void, RootState, null, DebtAction> => {
  return async (dispatch) => {
    try {
      dispatch(setDebtsLoaded(false))
      const resp = await debtApi.getDebts(store.getState().debt.debtFilter)
      dispatch(setDebts(resp.data.data))
      dispatch(setTotalDebts(resp.data.totalElement))
    } catch (e) {
      if (e.response && e.response.status && e.response.status === 401) {
        const resp = await debtApi.getDebts(store.getState().debt.debtFilter)
        dispatch(setDebts(resp.data.data))
        dispatch(setTotalDebts(resp.data.totalElement))
      }
    } finally {
      dispatch(setDebtsLoaded(true))
    }
  }
}
